export enum WorkflowPartyType {
  Party = 'company',
  Counterparty = 'counter',
}
